import { Grid, Group, Stack, Text, Textarea, Title, Paper } from "@mantine/core";
import { industries, skills } from "./data";
import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";

export default function AboutMe({ form, showError }) {
  const [selectedExperts, setSelectedExperts] = useState(
    form.values.expert_in.map((m) => ({ label: m, value: m }))
  );
  const [selectedSkills, setSelectedSkills] = useState(
    form.values.skills.map((m) => ({ label: m, value: m }))
  );
  const [selectedIndustries, setSelectedIndustries] = useState(
    form.values.industries.map((m) => ({ label: m, value: m }))
  );
  return (
    <>
    <Paper p="sm" >
      <Stack spacing={2}>
        <Group position="apart" className="mb-1">
          <Title order={4} className="mt-1">
            About Me
          </Title>
          <Text align="right" mr={3} fw={600} size="sm">
            {form.values.about_me.length}/500
          </Text>
        </Group>
        <Textarea
          radius="md"
          size="md"
          placeholder="Share a bit about yourself (max 500 characters)"
          defaultValue={form.values.about_me}
          onChange={(event) => {
            const updatedValue = event.currentTarget.value;
            form.setFieldValue("about_me", updatedValue.slice(0, 500));
          }}
          error={form.errors.about_me}
          minRows={3}
          maxLength={500}
        />
        <Text size="sm" c="dimmed">
          Use this section to share your personality, interests, or anything else you'd like others to know.
        </Text>
      </Stack>
    </Paper>

    <Paper p="sm" className="lg:mt-4">
  <Stack spacing={4}>

    <Group position="apart" className="mb-1">
      <Title order={4} className="mt-1">Expert In</Title>
      <Text align="right" mr={3} fw={600} size="sm">
        {form.values.expert_in.length}/5
      </Text>
    </Group>
    <MultiSelect
      isCreatable={true}
      placeholder="Select up to 5 areas of expertise"
      options={skills}
      hasSelectAll={false}
      value={selectedExperts}
      onChange={e => {
        if (e.length > 5) return;
        setSelectedExperts(e);
        form.setFieldValue(
          "expert_in",
          e.map(m => m.label)
        );
      }}
      className="max-w-full"
    />
    <Text size="sm" c="dimmed">
      Choose and showcase your specialized skills and knowledge.
    </Text>
    {/* {showError && !selectedExperts.length && (
      <Text fz="sm" c="red" className="mt-1 ml-auto">
        Select at least one field
      </Text>
    )} */}
  </Stack>
    </Paper>

    <Paper p="sm" className="lg:mt-4">
      <Stack spacing={4}>
        <Group position="apart" className="mb-1">
          <Title order={4} className="mt-1">Industries</Title>
          <Text align="right" mr={3} fw={600} size="sm">
            {form.values.industries.length}/5
          </Text>
        </Group>
        <MultiSelect
          isCreatable={true}
          placeholder="Select relevant industries (up to 5)"
          options={industries}
          hasSelectAll={false}
          value={selectedIndustries}
          onChange={e => {
            if (e.length > 5) return;
            setSelectedIndustries(e);
            form.setFieldValue(
              "industries",
              e.map(m => m.label)
            );
          }}
          className="max-w-full"
        />
        <Text size="sm" c="dimmed">
          Pick your industry focus to emphasize professional experience and sectors of interest.
        </Text>
        {showError && !selectedIndustries.length && (
          <Text fz="sm" c="red" className="mt-1 ml-auto">
            Select at least one industry
          </Text>
        )}
      </Stack>
    </Paper>

    <Paper p="sm" className="lg:mt-4">
      <Stack spacing={4}>
        <Group position="apart" className="mb-1">
          <Title order={4} className="mt-1">Skills</Title>
          <Text align="right" mr={3} fw={600} size="sm">
            {form.values.skills.length}/15
          </Text>
        </Group>
        <MultiSelect
          isCreatable={true}
          placeholder="Select up to 15 skills"
          options={skills}
          hasSelectAll={false}
          value={selectedSkills}
          onChange={e => {
            if (e.length > 15) return;
            setSelectedSkills(e);
            form.setFieldValue(
              "skills",
              e.map(m => m.label)
            );
          }}
          className="max-w-full"
        />
        <Text size="sm" c="dimmed">
          Select your specific talents and proficiencies.
        </Text>
        {/* {showError && !selectedSkills.length && (
          <Text fz="sm" c="red" className="mt-1 ml-auto">
            Select at least one skill
          </Text>
        )} */}
      </Stack>
    </Paper>

    </>
  );
}
